import { render, staticRenderFns } from "./VrstaSuorganizatoraCreate.vue?vue&type=template&id=2c89a060&scoped=true&"
import script from "./VrstaSuorganizatoraCreate.vue?vue&type=script&lang=js&"
export * from "./VrstaSuorganizatoraCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c89a060",
  null
  
)

export default component.exports